import VizauraApp from "./Pages/vizapp.jsx";
import AuthScreen from "./Pages/AuthScreen.jsx";
import { AuthProvider, useAuth } from "./context/AuthContext.jsx";

function Gate() {
  const { user } = useAuth();
  // Access is invite-only — you must be a signed-in (allow-listed) user.
  if (user) return <VizauraApp />;
  return <AuthScreen />;
}

export default function App() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
